<template>
<div>

    <div class="content-wrapper" style="min-height: 873px;">
        <div>
            <section class="content">

                <div class="row">
                    <!-- Left col -->
                    <section class="col-lg-8 connectedSortable">

                        <!-- /.nav-tabs-custom -->

                        <div class="box">
                            <div class="box-header">

                                <div class="row">
                                    <div class="col col-sm-6">
                                        <h1 class="box-title">{{$t('TRANSACTIONS_DETAILS')}} #{{ transaction.id }}</h1>
                                    </div>

                                    <div class="col col-sm-6">
                                        <div class="primary" style="text-align:right;">
                                            <button style="font-size:40px;" class="btn btn-default" v-bind:class="transaction.estatus | checkStatus"></button>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <!-- /.box-header -->

                            <div class="box-body">

                                <div v-if="loading == false">
                                    <div class="row">
                                        <div class="col col-sm-6">

                                            <th>{{$t('TRANSACTION_TABLE.COLUMS.ENTITY_NAME')}}:</th>
                                            <h4>{{ transaction.store_Name }}</h4>

                                            <br>

                                            <th>{{$t('TRANSACTION_TABLE.COLUMS.ENTITY_ID')}}:</th>
                                            <h4>{{ transaction.store_ID }}</h4>

                                            <br>

                                            <th>{{$t('TRANSACTION_TABLE.COLUMS.USERS') }}:</th>
                                            <h4>{{ transaction.user }}</h4>

                                            <br>

                                            <th>{{$t('TRANSACTION_TABLE.COLUMS.AMOUNT')}}:</th>
                                            <h4>{{ transaction.amount | Decimal }}</h4>

                                            <br>

                                            <th>{{ $t('PRODUCT')}}:</th>
                                            <h4>{{ transaction.product }}</h4>

                                            <br>

                                            <th>{{$t('HOST') }}:</th>
                                            <h4>{{ transaction.host }}</h4>
                                            <br>
                                            <th>{{ $t('TRANSACTION_TABLE.COLUMS.DATE')}}:</th>
                                            <h4>{{ transaction.date | formatDate }}</h4>

                                        </div>
                                        <div class="col col-sm-6">
                                            <th>{{$t('STATUS')}}:</th>
                                            <h4>{{ transaction.status }}</h4>

                                            <br>

                                            <th>{{$t('RESPONSE')}}:</th>
                                            <h4>{{$t('CODE')}}:{{ transaction.resp_Code }}</h4>
                                            <h4>{{$t('DESC')}}:{{ transaction.resp_Desc }}</h4>

                                            <br>

                                            
                                            <th>{{$t('TRANSACTION_TABLE.COLUMS.PIN_PTHONE_SERIAL')}}:</th>
                                            <h4>{{$t('PIN')}}:{{ transaction.pin_Phone }}</h4>
                                            <h4>{{$t('SERIAL')}}:{{ transaction.serial }}</h4>

                                            <br>

                                            <th>{{$t('TRANSACTION_TYPE.NAME')}}:</th>
                                            <h4>{{ transaction.transaction_Type}}</h4>

                                            <br>

                                            <th>{{ $t('BALANCE_AFTER')}}:</th>
                                            <h4>{{ transaction.balance_After }}</h4>

                                            <br>

                                            <th>{{$t('TRANSACTION_TABLE.COLUMS.AUTH_CODE') }}:</th>
                                            <h4>{{ transaction.auth_Number }}</h4>

                                            <br>

                                            <th>{{ $t('TRANSACTION_TABLE.COLUMS.DATE')}}:</th>
                                            <h4>{{ transaction.date }}</h4>

                                        </div>
                                    </div>

                                    <button class="btn btn-primary" type="button" @click="doPetition( transaction.id )">{{btn_text | translate }}</button>
                                    <button class="btn btn-default" @click="back">{{ $t('CANCEL')}}</button>
                                </div>
                                <div v-else>
                                    <center>
                                        <div class="fa fa-spinner fa-spin" style="font-size:100px;"></div>
                                    </center>
                                </div>

                            </div>
                        </div>

                    </section>

                </div>
            </section>

        </div>
    </div>
</div>
</template>

<script>
import swal from "sweetalert";

export default {
    name: "TransactionDetails-log",

    mounted() {
        this.getOne(this.$route.params.id);
    },
    data() {
        return {
            loading: false,
            transaction: {},
            btn_text: "REQUEST_REFUND"
        };
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        async getOne(id) {
            let self = this;

            try {
                self.loading = true;
                let response = await self.$store.state.services.transactionLogService.getOne(
                    id,
                    JSON.parse(self.$store.getters.user).token
                );

                if (response.data.estatus == "Aprobado") self.btn_text = "MAKE_REFOUND";
                if (response.data.estatus == "Pendiente")
                    self.btn_text = "RESEND_REQUEST";
                self.transaction = response.data;
            } catch (reason) {
                swal({
                    title: reason.response.data.error,
                    icon: "warning",
                    dangerMode: false
                });
            } finally {
                self.loading = false;
            }
        },
        doPetition(id) {
            let self = this;

            swal({
                title: this.$t("ARE_YOU_SURE?"),
                text: this.$t("DETAILQUESTION"),
                icon: "warning",
                buttons: [this.$t("No, CANCEL"), this.$t("YES, CONTINUE")],
                dangerMode: true
            }).then(async willDelete => {
                if (willDelete) {
                    try {
                        self.loading = true;
                        let response = await self.$store.state.services.transactionLogService.sendEmailRequest(
                            id,
                            JSON.parse(self.$store.getters.user).token
                        );
                        self.loading = false;
                        swal(response.data.message, {
                            icon: response.data.icon
                        });
                    } catch (reason) {
                        swal({
                            title: this.$t("ERROR REQUEST DID NOT SEND"),
                            text: `${this.$t("REASON")}: ${reason.response.data.error}`,
                            icon: "error"
                        });
                    } finally {
                        self.loading = false;
                    }
                } else {
                    swal(this.$t("PETITION NOT REALIZED"));
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/TransactionLogs/details.vue